import { createContext, useContext, type ReactNode } from 'react'

interface TenantContextValue {
  tenantId: string | null
}

const TenantContext = createContext<TenantContextValue | undefined>(undefined)

interface TenantProviderProps {
  children: ReactNode
  tenantId: string | null
}

export function TenantProvider({ children, tenantId }: TenantProviderProps) {
  return <TenantContext.Provider value={{ tenantId }}>{children}</TenantContext.Provider>
}

export function useTenant() {
  const context = useContext(TenantContext)
  if (context === undefined) {
    throw new Error('useTenant must be used within a TenantProvider')
  }
  return context
}
